<template>
  <div class="expired-container">
    <el-table
      class="recommend-table"
      :data="productList"
      size="mini"
      style="width: 100%"
      v-loading="isLoading"
    >
      <el-table-column prop="createOn" label="创建时间" width="180">
        <template slot-scope="scope">
          {{ scope.row.createOn | date }}
        </template>
      </el-table-column>
      <el-table-column prop="productName" label="物料名称" width="250">
      </el-table-column>
      <el-table-column label="品项">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.quality.name | qualityType"
            size="mini"
            v-if="scope.row.quality"
          >
            {{ scope.row.quality.name }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" label="数量"> </el-table-column>
      <el-table-column prop="price" label="价格"> </el-table-column>
      <el-table-column prop="priceDate" label="价格有效期" width="180">
        <template slot-scope="scope">
          {{ scope.row.priceDate | date }}
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" width="250">
      </el-table-column>
      <el-table-column label="产品图片">
        <template slot-scope="scope">
          <el-image
            style="width: 40px; height: 40px"
            v-if="scope.row.uploadFiles.length > 0"
            :src="scope.row.uploadFiles[0].sitePath"
            :preview-src-list="previewFiles(scope.row.uploadFiles)"
          >
            <div slot="error" class="image-slot">
              <img
                src="@images/watermark.jpg"
                style="width: 40px; height: 40px;"
                alt=""
              />
            </div>
          </el-image>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      productList: [],
      isLoading: false
    }
  },
  created() {
    this.getRecommendList()
  },
  methods: {
    getRecommendList() {
      this.isLoading = true
      const params = {
        productName: '',
        state: '已过期',
        startDate: '',
        endDate: '',
        skipCount: 0,
        maxResultCount: 10
      }
      this.$http
        .get('/api/services/inquiryApp/productRecommend/GetAll', params)
        .then(res => {
          this.productList = res.result.items
          this.isLoading = false
        })
        .catch(err => {
          console.log(err)
          this.$message.error('获取数据失败！')
          this.isLoading = false
        })
    },
    previewFiles(files) {
      let arr = []
      if (files) {
        files.forEach(item => {
          arr.push(item.sitePath)
        })
      }
      return arr
    }
  }
}
</script>
<style lang="less" scoped>
.expired-container {
  padding: 20px;
  height: 100%;
  overflow: auto;
}
.el-table {
  /deep/ th {
    .cell {
      color: #2f343c;
      font-size: 14px;
      line-height: 33px;
      font-weight: 600;
    }
  }
}
</style>
